(function () {
  angular.module('MktzapApp.Controllers')
    .controller('EventController', eventController);

  eventController.$inject = ['FoundationApi', 'EventService', 'NotificationService', 'ngTableParams'];

  function eventController (FoundationApi, EventService, NotificationService, ngTableParams) {
    var vm = this;

    vm.total = 0;
    vm.getAll = getAll;
    vm.params = [];
    vm.event = {};

    getAll();

    function getAll () {
      vm.eventsTable = new ngTableParams({
        page: 1,
        count: 15
      }, {
        getData: function ($defer, params) {
          vm.params.pagingParameters = params.url();
          EventService
            .getByLabelWithPagination(vm.params)
            .$promise
            .then(function (data) {
              if (data) {
                $defer.resolve(data.events);
                params.total(data.total);
              }
            }).catch(function (data) {
              NotificationService.errorHandler(data, 'Erro ao carregar!');
              vm.total = 0;
            });
        }
      });
    }

    vm.add = function () {
      vm.event = {};
      FoundationApi.publish('modal', 'open');
    }

    vm.save = function (payload) {
      if (payload._id != undefined) {
        EventService
          .update(payload)
          .$promise
          .then(function (data) {
            if (data.success) {
              getAll();
              NotificationService.successHandler(data, 'Operação realizada com sucesso!');
              FoundationApi.publish('modal', 'close');
            }
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao salvar!');
          })
        return;
      }
      EventService
        .store(payload)
        .$promise
        .then(function (data) {
          if (data.success) {
            getAll();
            NotificationService.successHandler(data, 'Operação realizada com sucesso!');
            FoundationApi.publish('modal', 'close');
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao salvar!');
        })
    }

    vm.delete = function (payload) {
      var confirmation = confirm('Deseja confirmar essa operação?')
      if (confirmation) {
        EventService
          .delete(payload)
          .$promise
          .then(function (data) {
            getAll();
            if (data.success) {
              NotificationService.successHandler(data, 'Operação realizada com sucesso');
              FoundationApi.publish('validacao', 'close');
            }
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao deletar!');
          })
      }
    }

    vm.edit = function (event) {
      vm.event = angular.copy(event);
      FoundationApi.publish('modal', 'open');
    }
  }
})();
